import {LIST_STATISTIC_LO12V2} from "./types";

const init = {
    list: []
}


export default (state = init, {type, payload}) => {
    switch (type) {
        case LIST_STATISTIC_LO12V2:
            return {
                ...state,
                list: payload,
            };
        default:
            return state;
    }
}
